// extracted by mini-css-extract-plugin
export default {"sideDrawer__content":"CompanySearchTemplate_sideDrawer__content__oKDlf"};